import { Component, Event, EventEmitter, Host, Listen, Prop, h } from '@stencil/core';
import { addStyleSettings } from '../../utils/custom-style';
import { getPriceBreakdown } from '../../utils/order-price';


@Component({
  tag: 'tambr-price-confirm-dialog',
  styleUrl: 'tambr-price-confirm-dialog.css',
  shadow: true,
})
export class TambrPriceConfirmDialog {

  @Prop() loading: boolean = false;
  @Event() tambrPriceConfirmDialogResponse: EventEmitter<string>;

  @Listen('click') onClickEvent( ev: MouseEvent ) {
    const targets = ev.composedPath() as EventTarget[];
    if ( targets[0] instanceof Element && targets[0].id === 'tambr-price-confirmation-dialog' ) {
      return this.emit('cancel');
    }
  }

  emit( response: string ) {
    this.tambrPriceConfirmDialogResponse.emit( response );
  }

  render() {
    return (
      <Host style={ addStyleSettings() }>
        <div id="tambr-price-confirmation-dialog" class="tambr-overlay">
          <div class='tambr-modal-window price-confirm-window'>

            <div class="tambr-modal-header">
              <tambr-icon type="close" class="close-button" onClick={ () => this.emit('cancel') } />
            </div>

            <div class='tambr-modal-title'>The price has changed</div>

            <div class="tambr-modal-body">
              <div class="confirmation-message">Please confirm the price below.</div>

              <tambr-checkout-order-price priceBreakdown={ getPriceBreakdown().priceBreakdown } />

              <div class="tambr-action-buttons row">
                <div class="tambr-clear-button" onClick={ () => this.emit('cancel') }>Cancel</div>
                
                <button type="button"
                  onClick={ () => this.emit('confirm') }
                  disabled={ this.loading }
                  class={ 'tambr-button' + (this.loading ? ' loading' : '') }>
                    <div class="tambr-button-loading"><div>Loading...</div></div>
                    <span>Accept</span>
                </button>
              </div>              
            </div>

          </div>          
        </div>
      </Host>
    );
  }

}
